import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { pricingApi } from '../services/api';
import { createPricingResource } from '../billing/pricing-resource';

const resource = createPricingResource(() => pricingApi.getPublicPricing());

/** Explicit currency codes distinguish USD from the former CAD prices. */
export function formatPlanPrice(amount: number, currency: string): string {
  return new Intl.NumberFormat(currency === 'SAR' ? 'en-SA' : 'en-US', {
    style: 'currency', currency, currencyDisplay: 'code', maximumFractionDigits: 2,
  }).format(amount);
}

export function usePublicPricing() {
  const state = useSyncExternalStore(resource.subscribe, resource.snapshot, resource.snapshot);
  const retry = useCallback(() => resource.refresh(true), []);
  useEffect(() => {
    void resource.refresh();
    const refresh = () => { void resource.refresh(); };
    const timer = window.setInterval(refresh, 60_000);
    window.addEventListener('focus', refresh);
    return () => { clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, []);
  return { ...state, retry, formatPlanPrice };
}
